<template>
  <q-header elevated class="bg-white text-primary header">
    <q-toolbar class="toolbar">
      <Button icon="menu" color="standard" @click="$emit('toggleMenu')" dense />
      <img
        :src="logoUrl"
        :alt="logoAlt"
        :width="logoWidth"
        class="cursor-pointer q-ml-md"
        @click="$emit('click-logo')"
      />
      <q-space />
      <slot name="header-right"></slot>
    </q-toolbar>
  </q-header>
</template>

<script>
import Button from '../components/Button.vue';

export default {
  name: 'Header',
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
    },
    logoAlt: {
      type: String,
    },
    logoUrl: {
      type: String,
    },
    logoWidth: {
      type: Number,
      default: 150,
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 4000;
}
.toolbar {
  height: 60px;
}
</style>
